import { action, observable } from 'mobx';
import {
    Anexo,
    Cargo,
    CargosResponse,
    ConsultaImpuestos,
    ConsultaImpuestosResponse,
    ConsultaMensual,
    ConsultaMensualResponse,
    Months,
    Municipio,
    Roles,
    RolesResponse,
    OrganismoOperador
} from '../models';
import {
    FiltrosAnexos,
    FiltrosConsultas,
    FiltrosReporteMensual,
    TipoImpuesto,
    FiltrosReporteAnual
} from '../models/Consultas';
import { requestStore } from './requestStore';

export class ConsultaStore {
    @observable
    forms: ConsultaImpuestos[] = [];

    @observable
    registrosMensual: ConsultaMensual[] = [];

    @observable
    listaMunicipios: Municipio[] = [];

    @observable
    filtros: FiltrosConsultas = {
        Municipio: 0,
        Ejercicio: 0,
        Mes: 0,
        Tipo: 0,
        Estado: 0,
        Captura: '0',
        Bandera: true
    };

    @observable
    cargando: boolean = false;

    @observable
    tipoAnexo: TipoImpuesto | null = null;

    @observable
    visibleAnexos: boolean = false;

    @observable
    visibleAnios: boolean = false;

    @observable
    visibleConsultaAnexos: boolean = false;

    @observable
    listaAnexos: Anexo[] = [];

    @observable
    filtrosAnexos: FiltrosAnexos = { ejercicio: 0, anexo: 0 };

    @observable
    roles: Roles[] = [];

    @observable
    cargos: Cargo[] = [];

    @observable
    filtrosReporteMensual: FiltrosReporteMensual = { ejercicio: 0, mes: 0, municipio: 0 };

    @observable
    listaOrganismos: OrganismoOperador[] = [];

    @observable
    filtrosReporteAnual: FiltrosReporteAnual = {
        Ejercicio: 0,
        Municipio: 0,
        Tipo: 0,
        soapap: false
    };

    @observable
    listaMunicipiosSoapap: Municipio[] = [];


    @action inicializarFiltros() {
        this.filtros = {
            Municipio: 0,
            Ejercicio: 0,
            Mes: 0,
            Tipo: 0,
            Estado: 0,
            Captura: '0',
            Bandera: true
        };
    }

    @action inicializarFiltrosAnexo() {
        this.filtrosAnexos = { ejercicio: 0, anexo: 0 };
        this.listaAnexos = [];
    }

    @action inicializarFiltroTipoAnexo() {
        this.tipoAnexo = null;
        this.visibleAnexos = false;
        this.visibleAnios = false;
    }

    @action
    async getConsulta(Primera: boolean) {
        this.cargando=true;
        this.filtros.Bandera = Primera === false ? Primera : true;
        const response = await requestStore.getConsulta(this.filtros);
        if (response) {
            response.forEach(registro => {
                registro.mesString = this.mesString(registro.mes);
            });
            this.forms = response as ConsultaImpuestosResponse;
        }
        this.cargando=false;
    }

    @action
    async getConsultaMensual() {
        const response = await requestStore.getConsultaMensual(
            this.filtros.Ejercicio,
            this.filtros.Mes,
            this.filtros.Municipio
        );
        if (response) {
            this.registrosMensual = response as ConsultaMensualResponse;
        }
    }

    @action
    async getMunicipios() {
        const response = await requestStore.getMunicipios();
        if (response) {
            this.listaMunicipios = response;
        }
    }

    @action
    async getReportePdf(record: ConsultaImpuestos) {
        const tipoReporte = record.tipo.toUpperCase() === 'AGUA' ? 1 : 2;
        const response = await requestStore.getReportePdf(tipoReporte, record.id);
        return response;
    }

    @action
    async getAnexos(tipo: number) {
        const response = await requestStore.getAnexos(tipo);
        if (response) {
            this.listaAnexos = response as Anexo[];
        }
    }

    @action
    async getExcelAnexo() {
        const response = await requestStore.getExcelAnexo(
            this.filtrosAnexos.anexo,
            this.filtrosAnexos.ejercicio
        );
        return response;
    }

    @action
    async getReporteMensualExcel() {
        const response = await requestStore.getReporteMensualExcel(
            this.filtros.Ejercicio,
            this.filtros.Mes,
            this.filtros.Municipio
        );
        return response;
    }

    @action
    mesString(mes: number) {
        return Months[mes - 1];
    }

    @action
    async getRoles() {
        const response = await requestStore!.getConsultaRoles();
        if (response) {
            this.roles = response as RolesResponse;
        }
    }

    @action
    async getCargos() {
        const response = await requestStore!.getConsultaCargos();
        if (response) {
            this.cargos = response as CargosResponse;
        }
    }

    @action
    async getOrganismosOperadores() {
        const response = await requestStore!.getOrganismoOperador();
        if (response) {
            this.listaOrganismos = response;
        }
    }

    @action
    async getReporteAnual() {
        const response = await requestStore.getReporteAnualPdf(
            this.filtrosReporteAnual.Tipo,
            this.filtrosReporteAnual.Ejercicio,
            this.filtrosReporteAnual.Municipio,
            this.filtrosReporteAnual.soapap
        );
        return response;
    }

    @action
    async getMunicipiosSoapap() {
        const response = await requestStore.getMunicipiosSoapap();
        if (response) {
            this.listaMunicipiosSoapap = response;
        }
    }
}

export const consultaStore = new ConsultaStore();
export default consultaStore;
